import React from "react";
import "./WhyChooseGlamurPaints.css";
import w1 from "../assets/w1.svg";
import w2 from "../assets/w2.svg";
import w3 from "../assets/w3.svg";
import w4 from "../assets/w4.svg";
import w5 from "../assets/w5.svg";
import w6 from "../assets/w6.svg";
import w7 from "../assets/w7.svg";
import w8 from "../assets/w8.svg";
import w9 from "../assets/w9.svg";
import w10 from "../assets/w10.svg";

const features = [
  {
    icon: w1,
    title: "40+ Years of Proven Excellence",
    description:
      "When you choose Glamur Paints, you’re choosing four decades of proven expertise in Pakistan’s paint industry. Since 1984, we’ve been perfecting our formulations and understanding the unique moods of Pakistani customers.",
  },
  {
    icon: w2,
    title: "Honest Pricing, No Hidden Costs",
    description:
      "We believe in transparent pricing that reflects true value. Unlike competitors who inflate prices only to offer false discounts, at Glamur Paints provides genuinely competitive pricing without compromising on quality. This honest approach has made us the preferred choice.",
  },
  {
    icon: w3,
    title: "Climate-Specific Formulations",
    description:
      "Our paints are specially designed for Pakistan’s diverse climate conditions. From Sindh Province’s coastal humidity to the extreme temperatures of interior regions, Glamur Paints products are formulated to perform exceptionally in local weather conditions.",
  },
  {
    icon: w4,
    title: "Strong Regional Presence",
    description:
      "Our strongest presence in Sindh Province ensures quick delivery, readily available stock, and immediate customer support. This regional strength, combined with our nationwide distribution, makes us accessible to customers across Pakistan’s major cities.",
  },
  {
    icon: w5,
    title: "Uncompromising Quality Standards",
    description:
      "While many paint companies compromise on quality to reduce costs, Glamur Paints maintains strict quality standards across all our products. Our paints undergo rigorous testing to ensure superior coverage, durability, and color retention qualities that make us stand out.",
  },
  {
    icon: w6,
    title: "Direct Customer Relationships",
    description:
      "We’ve built our reputation by establishing direct relationships with our customers. While many local painters in Pakistan recommend paints based on their commission benefits, we educate customers directly about paint quality, helping them make informed decisions based on their actual needs.",
  },
  {
    icon: w7,
    title: "Comprehensive Product Range",
    description:
      "With seven specialized paint types covering all applications, Glamur Paint offers comprehensive solutions for every painting need superior interior finishes that beautify living spaces , weather-resistant exterior paints that protect against harsh elements, specialized coatings perfect for unique artistic applications.",
  },
  {
    icon: w8,
    title: "Trusted by Professionals",
    description:
      "Contractors, architects, and professional painters across Pakistan trust Glamur Paints for their projects. Our consistent quality and reliable performance have earned us a reputation as one of the leading paint brands in Pakistan’s construction industry.",
  },
  {
    icon: w9,
    title: "Innovation Meets Tradition",
    description:
      "We combine traditional paint-making expertise with modern innovation. This unique approach allows us to offer time-tested quality while incorporating the latest advancements in paint technology, keeping us at the forefront of Pakistan’s paint industry.",
  },
  {
    icon: w10,
    title: "Customer-Centric Service",
    description:
      "Every customer interaction with Glamur Paints is designed around your satisfaction. From product selection guidance to after-sales support, our team is committed to ensuring your complete satisfaction with our paint products and services.",
  },
];

export default function WhyChooseGlamurPaints() {
  return (
    <section className="why-choose-section">
      <div className="features-grid">
        {/* First 8 cards */}
        {features.slice(0, 8).map(({ icon, title, description }, i) => (
          <article key={i} className="feature-card2">
            <div className="icon-placeholder">
              <img src={icon} alt={`${title} icon`} />
            </div>
            <h3>{title}</h3>
            <p>{description}</p>
          </article>
        ))}

        {/* Last 2 cards wrapped inside full-span container */}
        <div className="last-row-desktop">
          {features.slice(-2).map(({ icon, title, description }, i) => (
            <article key={i} className="feature-card2">
              <div className="icon-placeholder">
                <img src={icon} alt={`${title} icon`} />
              </div>
              <h3>{title}</h3>
              <p>{description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
